import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import { media } from "@atlaskit/primitives";

import { wacToken } from "@/libraries/design/foundations";

import {
    CollectionCardCarousel,
    CollectionCardCarouselProps
} from "../../components/contentful-relay-components/collection-card-carousel-contentful-relay";

const collectionsWrapperStyles = css({
    "insetBlockEnd": "-120px",
    "margin": "auto",
    "paddingBottom": "48px",
    "width": "1200px",
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",

    "@media (max-width: 639.99px)": {
        insetInlineStart: "calc(50%-152px)",
        width: "304px"
    },
    "@media (min-width: 640px) and (max-width: 767.99px)": {
        insetInlineStart: "calc(50%-304px)",
        width: "608px"
    },
    "@media (min-width: 768px) and (max-width: 1023.99px)": {
        insetInlineStart: "calc(50%-360px)",
        width: "720px"
    },
    "@media (min-width: 1024px) and (max-width: 1279.99px)": {
        insetInlineStart: "calc(50% - 400px)",
        width: "800px"
    }
});

const sectionDividerStyles = css({
    "height": 1,
    "background": wacToken("color.neutral.light300"),
    "position": "relative",
    "insetBlockStart": -48,
    "width": "1200px",
    "@media (max-width: 639.99px)": {
        insetInlineStart: "calc(50%-152px)",
        width: "304px"
    },
    "@media (min-width: 640px) and (max-width: 767.99px)": {
        insetInlineStart: "calc(50%-304px)",
        width: "608px"
    },
    "@media (min-width: 768px) and (max-width: 1023.99px)": {
        insetInlineStart: "calc(50%-360px)",
        width: "720px"
    },
    "@media (min-width: 1024px) and (max-width: 1279.99px)": {
        insetInlineStart: "calc(50% - 400px)",
        width: "800px"
    },
    "@media(min-width: 1280px)": {
        margin: "auto"
    }
});

const templateSectionStyles = css({
    display: "block"
});

const carouselTitleStyles = css({
    fontSize: "2.25rem",
    lineHeight: "2.625rem",
    fontWeight: 500,
    // eslint-disable-next-line local/ensure-wac-token-usage
    color: "#1d3059",
    fontFamily: wacToken("font.charlie.display"),
    margin: "0 0 8px 0",
    textAlign: "center",

    [media.below.sm]: {
        fontSize: "2rem",
        lineHeight: "2.375rem"
    }
});

const subTextStyles = css({
    textAlign: "center"
});

type TemplateCarouselSectionProps = CollectionCardCarouselProps;

const TemplateCarouselSection = ({
    collections
}: TemplateCarouselSectionProps) => {
    return (
        <div
            css={collectionsWrapperStyles}
            data-testid="template-carousel-section-relay"
        >
            <h2 css={carouselTitleStyles}>
                <FormattedMessage
                    id="confluence.template.carousel.heading"
                    defaultMessage="Template collections"
                />
            </h2>
            <p css={subTextStyles}>
                <FormattedMessage
                    id="confluence.template.carousel.subtext"
                    defaultMessage="See curated templates targeted to help achieve work and collaboration goals"
                />
            </p>
            <section css={templateSectionStyles}>
                <CollectionCardCarousel collections={collections} />
            </section>
        </div>
    );
};

TemplateCarouselSection.displayName = "TemplateCarouselSection";

export { TemplateCarouselSection };

export const SectionDivider = () => <div css={sectionDividerStyles} />;
